import React from "react";
const LoaderDot = ({ text }) => {
  return (
    <div className="d-flex align-items-center justify-content-center flex-column py-5">
      <div className="loader-dotted mb-2"></div>
      <div className="pt-5 text-primary">{text}</div>
    </div>
  );
};
export default LoaderDot;
